/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import { string, shape, func } from 'prop-types';
import { getImageUrl } from 'helpers/Utils';
import { Small, Heading } from 'components/common';

import './PromotionalSurvey.scss';

const PromotionalSurvey = (props) => {
  const {
    title,
    logo,
    question,
    message,
    thankYouMessage,
    label,
    icon,
    callback,
  } = props;
  const [click, setClick] = useState(false);

  const handleClick = () => {
    setClick(true);
    if (callback) {
      callback();
    }
  };

  return (
    <div className="promotional-survey" onClick={handleClick}>
      <div className="layout-row">
        <div className="layout-column column-md-12 title-wrapper">
          <Heading primary as="h3">
            {title}
          </Heading>
        </div>
        <div className="layout-column column-xs-2 column-sm-1">
          <img src={logo && getImageUrl(logo, { width: 20 })} alt={title} />
        </div>
        <div className="layout-column column-xs-8 column-sm-8 question" style={{ display: 'flex' }}>
          <div className={!click && 'active'}>
            <Heading primary as="h4">
              {question}
              <div>
                <Small secondary>
                  {message}
                </Small>
              </div>
            </Heading>
          </div>
          <div className={click && 'active'}>
            <Heading primary as="h2">
              {thankYouMessage}
            </Heading>
          </div>
        </div>
        <div className="layout-column column-xs-2 column-sm-3 ctrLabel">
          <Heading primary as="h3">
            {label}
          </Heading>
          <img
            src={icon && getImageUrl((click) ? icon.active : icon.normal, { width: 8 })}
            alt={title}
          />
        </div>
      </div>
      <div className="layout-row">
        <div className="layout-column">
          <hr className="full" />
        </div>
      </div>
    </div>
  );
};

PromotionalSurvey.defaultProps = {
  callback: null,
};

PromotionalSurvey.propTypes = {
  title: string.isRequired,
  logo: string.isRequired,
  question: string.isRequired,
  message: string.isRequired,
  thankYouMessage: string.isRequired,
  label: string.isRequired,
  icon: shape.isRequired,
  callback: func,
};

export default PromotionalSurvey;
